module.exports = __webpack_public_path__ + "bg-card-0.jpg";